import { DeleteForever, Star, AddCircleOutline } from '@mui/icons-material';
import { InputAdornment, TextField, Typography } from '@mui/material';
import { Box } from '@mui/system';
import { GenButton } from '@pinnacleautomotive/clarity-components';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

const StartSpecialRequest = () => (
  <Star
    sx={{
      borderRadius: '50%',
      background: theme => theme.palette.info.main,
      color: theme => theme.palette.background.paper,
      padding: theme => theme.spacing(0.4),
    }}
  />
);

const SpecialRequestItem = ({ data, onDelete }) => (
  <Box
    display="flex"
    alignItems="center"
    flexDirection="row"
    py={1}
    px={2}
    mb={1}
    sx={{
      background: theme => theme.palette.background.paper,
      border: 1,
      borderColor: theme => theme.palette.divider,
      borderRadius: 1,
    }}
  >
    <StartSpecialRequest />
    <Typography pl={1} flexGrow={1}>
      {data}
    </Typography>
    <GenButton
      onClick={onDelete}
      sx={{ marginLeft: 'auto', color: theme => theme.palette.grey[900] }}
      iconForIconButton={<DeleteForever />}
    />
  </Box>
);

const SpecialRequests = ({
  specialRequests,
  onAddSpecialRequest,
  onRemoveSpecialRequest,
  autoFocus,
}) => {
  const { t } = useTranslation('orders');
  const [newSpecialResquest, setNewSpecialRequest] = useState('');

  const onKeyDownHandler = event => {
    event.keyCode === 13 && addSpecialRequestHandler();
  };

  const addSpecialRequestHandler = () => {
    !!newSpecialResquest && onAddSpecialRequest(newSpecialResquest);

    setNewSpecialRequest('');
  };
  return (
    <Box>
      {specialRequests?.map((item, index) => (
        <SpecialRequestItem
          key={index}
          data={item}
          onDelete={() => onRemoveSpecialRequest(index)}
        />
      ))}
      <Box mb={2}>
        <TextField
          fullWidth
          autoFocus={autoFocus}
          size="small"
          value={newSpecialResquest}
          onKeyDown={onKeyDownHandler}
          onBlur={addSpecialRequestHandler}
          placeholder={t('newOrder.extras.placeholder')}
          onChange={event => setNewSpecialRequest(event.target.value)}
          sx={{
            background: theme => theme.palette.background.paper,
          }}
          inputProps={{ maxLength: 120 }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <StartSpecialRequest />
              </InputAdornment>
            ),
          }}
        />
      </Box>
      <GenButton
        startIcon={<AddCircleOutline />}
        disabled={!newSpecialResquest}
        onClick={addSpecialRequestHandler}
        text={t('newOrder.extras.addRequest')}
      />
    </Box>
  );
};

export default SpecialRequests;
